import { useContext } from "react";
import AuthContext from "./AuthContext";

interface AuthContextProps {
  isAuthenticated: boolean | null;
  isInitialized: boolean;
  user: any;
  login: () => Promise<void>;
  logout: () => void;
  updateProfile: (payload? : any,id? : string) => Promise<void>;
}

const useAuth = () : AuthContextProps => {
  const data = useContext(AuthContext);
  return data;
};

export default useAuth;
